var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoodsReceiptActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.683,
    height: 21.235,
    viewBox: "0 0 16.683 21.235",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Goods_Receipt-act",
    "data-name": "Goods Receipt-act",
    transform: "translate(-213.206 -168.812)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M450.761,173.361h3.033a.758.758,0,0,0,.536-1.294l-3.033-3.033a.758.758,0,0,0-1.294.536v3.03a.758.758,0,0,0,.758.758Z",
    transform: "translate(-224.663)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M229.132,174.12H226.1a1.521,1.521,0,0,1-1.516-1.516V169.57a1.513,1.513,0,0,1,.2-.758h-10.82a.761.761,0,0,0-.758.758v19.715a.755.755,0,0,0,1.1.675l2.54-1.266,1.13,1.13a.777.777,0,0,0,.538.22.709.709,0,0,0,.341-.083l2.639-1.319,1.911,1.274a.731.731,0,0,0,.834,0l1.911-1.274,2.639,1.319a.755.755,0,0,0,1.1-.675v-15.37a1.512,1.512,0,0,1-.758.2Zm-11.374-1.52h3.033a.758.758,0,0,1,0,1.517h-3.033a.758.758,0,1,1,0-1.517Zm7.583,10.615h-7.583a.758.758,0,1,1,0-1.517h7.582a.758.758,0,0,1,0,1.517Zm0-3.033h-7.583a.759.759,0,0,1,0-1.517h7.582a.758.758,0,0,1,0,1.517Zm0-3.033h-7.583a.759.759,0,1,1,0-1.517h7.582a.758.758,0,1,1,0,1.517Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodsReceiptActive);
export default __webpack_public_path__ + "static/media/goods_receipt_active.c96e1696db3fe52fbedf8d75b30aff69.svg";
export { ForwardRef as ReactComponent };